/**
 * Suggested categories for the resource-upload dropdown — not a
 * constraint. `resourceType` is a plain string server-side so "other"
 * can carry a free-form value.
 *
 * Mirrors DRONE_RESOURCE_TYPES in the Hub's data-models/drone-resource.ts.
 */
export const DRONE_RESOURCE_TYPES = [
  'registration',
  'insurance',
  'manual',
  'invoice/proof-of-purchase',
  'maintenance-documentation',
  'other'
];
